(function ($) {
    // mobile filter open
    (function (){
        const filterBtn = $('#js-filter-btn');
        const filter = $('#js-filter');
        const filterBtnOpen = 'p-filter-btn--open';
        filterBtn.on('click', function() {
            $(this).toggleClass(filterBtnOpen);
            filter.slideToggle(200);
        });
    }());

    // active filter item
    (function (){
        const filterLabel = $('.p-filter__label');
        const filterInputRadio = $('.p-filter__input[type="radio"]');
        const filterInputCheck = $('.p-filter__input[type="checkbox"]');
        const filterInputActive = 'p-filter__label--active';
        filterInputRadio.on("click",function (e) {
            const radio = $(this);
            if (radio.is('.is-checked')) {
                radio.prop('checked',false).change().removeClass('is-checked').parent().removeClass(filterInputActive);
            } else {
                $("input:radio[name='"+radio.prop("name")+"'].is-checked").removeClass('is-checked').parent().removeClass(filterInputActive);
                radio.addClass('is-checked').parent().addClass(filterInputActive);
            }
        });

        filterInputCheck.on('click', function () {
            if ($(this).is(':checked')) {
                $(this).parent().addClass(filterInputActive);
            } else {
                $(this).parent().removeClass(filterInputActive);
            }
        });
    }());

})(jQuery);
